//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BlogFooterCta from '~/components/global/BlogFooterCta.vue';

const PAGE_SIZE = 150;

export default {
  components: { BlogFooterCta },
  layout: 'blog',

  async asyncData({ $content }) {
    const posts = await $content('blog')
      .only(['title', 'slug', 'excerpt', 'featuredImage', 'publishedOn'])
      .sortBy('publishedOn', 'desc')
      .fetch();
    return { posts };
  },

  data() {
    return { visibleCount: PAGE_SIZE };
  },

  computed: {
    visiblePosts() {
      return this.posts.slice(0, this.visibleCount);
    },
    hasMore() {
      return this.visibleCount < this.posts.length;
    }
  },

  methods: {
    loadMore() {
      this.visibleCount += PAGE_SIZE;
    }
  },

  head() {
    return {
      title: 'Blog | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Insights on inventory management, BOM workflows, and hardware development from the BOMIST team.'
        }
      ]
    };
  }
};
